import { createContext } from "react";

const MainPostsContext = createContext();
export default MainPostsContext;
